"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsFinancialProduct_1 = require("../../model/hsFinancialProduct");
var service_1 = require("../../../library/base/service");
var DetailInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(DetailInit, _super);
    function DetailInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '产品详情初始化接口';
        _this.code = '105025';
        _this.desc = '产品详情初始化接口';
        _this.requestParams = new hsFinancialProduct_1.DetailInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return DetailInit;
}(service_1.BaseService));
exports.DetailInit = DetailInit;
//# sourceMappingURL=detailInit.js.map